import styled, { css } from 'styled-components';
import theme from '../../styles/theme';

const DragAndDropWrapper = styled.div``;

const DragAndDrop = styled.div`
  cursor: pointer;
  border-radius: ${theme.borderRadius['border-radius-3']};
  border: dashed 2px ${({ useTheme }) => useTheme ? theme.colors.primary.border.regular : theme.colors.success.border.regular};
  place-items: center;
  padding: ${theme.spacing['spacing-4']};
  ${({ size }) => getSize(size)};
  ${({ disabled }) => disabled && getDisabled()}
`;

const DropBaseIcon = styled.div`
  border-radius: 100px;
  background-color: ${({ useTheme }) => useTheme ? theme.colors.primary.bg.weak : theme.colors.success.bg.weak};
  padding: 10px;
  width: max-content;
  place-self: center;
`;

const DropBaseIconWrapper = styled.div`
  border-radius: 100px;
  background-color: ${({ useTheme }) => useTheme ? theme.colors.primary.border.regular : theme.colors.success.border.weak};
  padding: 10px;
`;

const SuccessIcon = styled.div`
  padding: ${theme.spacing['spacing-6']} ${theme.spacing['spacing-3']}
    ${theme.spacing['spacing-6']} ${theme.spacing['spacing-6']};
  margin: ${theme.spacing['spacing-2']};

  ${({ size }) =>
    (size === 'sm' || size === 'auto') &&
    css`
      padding: ${theme.spacing['spacing-7']} ${theme.spacing['spacing-0']}
        ${theme.spacing['spacing-5']} ${theme.spacing['spacing-0']};
      margin: ${theme.spacing['spacing-0']};
    `}
`;

const MainTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing['spacing-2']};
`;

const FileInput = styled.input`
  display: none;
`;

const ActionWrapper = styled.div`
  padding: ${theme.spacing['spacing-2']};
  width: 100%;
  text-align: right;
`;

const getSize = (size) => {
  switch (size) {
    case 'sm':
      return css`
        max-width: 312px;
        flex-direction: column;
      `;
    case 'md':
      return css`
        min-width: 671px;
      `;
    case 'auto':
      return css`
        width: 100%;
        flex-direction: column;
        box-sizing: border-box;
      `;
  }
};

const getDisabled = () => css`
  background: ${theme.colors.neutral.bg.regular};
`;

export {
  DragAndDropWrapper,
  DragAndDrop,
  DropBaseIcon,
  DropBaseIconWrapper,
  SuccessIcon,
  MainTextWrapper,
  FileInput,
  ActionWrapper,
};
